import {
	Alert,
	alpha,
	Box,
	Button,
	Card,
	CardContent,
	Divider,
	FormControl,
	FormControlLabel,
	IconButton,
	InputLabel,
	Link,
	MenuItem,
	Modal,
	Select,
	Stack,
	Step,
	StepLabel,
	Autocomplete,
	Chip,
	Stepper,
	Switch,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TextField,
	Typography,
	Tooltip,
	CircularProgress,
} from "@mui/material";
import React, { useMemo } from "react";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import CloseIcon from "@mui/icons-material/Close";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useState } from "react";
import dayjs from "dayjs";
import { useEffect } from "react";
import QuantityTable from "../QuantityTable/QuantityTable";
import { ASSETS_BASE_URL } from "../../config";
import { useNavigate } from "react-router-dom";
import { Add as AddIcon, Remove as RemoveIcon, DeleteOutline as DeleteIcon, Check } from "@mui/icons-material";
import { useSite } from "../../context/siteContext";
import { useAuth } from "../../context/authContext";
import EditIcon from "@mui/icons-material/Edit";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Swal from "sweetalert2";
import { BUTTON, LABELS, MENU_ITEMS, PLACEHOLDER, TABLE_HEADERS, UI_TEXT, MESSAGES, ALERT_MESSAGES } from "../../constants";
import { useOptions } from "../../context/optionContext";
import { Trans, useTranslation } from "react-i18next";
import { getCustomerByIdForCusSites, getProdutsUniqueBySiteNumber, scheduleUpdate, schedule} from "../../services/scheduleOrderService";
import { getSiteAddressesNew } from "../../services/manageSitesService";
import { toast } from "../../context/ToastContext";

// Build translated option maps inside the component (after `t` exists).
const buildDT_BY_LE = (t) => ({
	AUSA: [
		{ term: "PPD-ADD", description: t("UI_TEXT.PREPAID_AND_ADD") },
		{ term: "COD", description: t("UI_TEXT.COLLECT_ON_DELIVERY") },
	],
	ACAN: [
		{ term: "PPD-ADD", description: t("UI_TEXT.PREPAID_AND_ADD") },
		{ term: "COD", description: t("UI_TEXT.COLLECT_ON_DELIVERY") },
	],
	EUUK: [
		{ term: "EXW", description: t("SHIPPING.EX_WORKS") },
		{ term: "DAP", description: t("SHIPPING.DELIVERY_AT_PLACE") },
		{ term: "DDP", description: t("SHIPPING.DELIVERY_DUTY_PAID") },
	],
});

const buildDM_BY_LE = (t) => ({
	AUSA: [
		{ code: "UPS-GND", description: t("UI_TEXT.UPS_GROUND") },
		{ code: "UPS-1DA", description: t("UI_TEXT.UPS_NEXT_DAY_AIR") },
		{ code: "UPS-1DM", description: t("SHIPPING.UPS_NEXT_DAY_AIR_AM_DELIVERY") },
		{ code: "UPS-2DA", description: t("SHIPPING.UPS_SECOND_DAY_AIR") },
		{ code: "FedEx-FG", description: t("UI_TEXT.FEDEX_GROUND") },
		{ code: "FedEx-F2", description: t("SHIPPING.FEDEX_SECOND_DAY_AIR") },
		{ code: "Speci-Spec", description: t("UI_TEXT.SPECIAL_INSTRUCTIONS") },
	],
	ACAN: [
		{ code: "UPS-GND", description: t("UI_TEXT.UPS_GROUND") },
		{ code: "UPS-1DA", description: t("UI_TEXT.UPS_NEXT_DAY_AIR") },
		{ code: "UPS-1DM", description: t("SHIPPING.UPS_NEXT_DAY_AIR_AM_DELIVERY") },
		{ code: "UPS-2DA", description: t("SHIPPING.UPS_SECOND_DAY_AIR") },
		{ code: "FedEx-FG", description: t("UI_TEXT.FEDEX_GROUND") },
		{ code: "FedEx-F2", description: t("SHIPPING.FEDEX_SECOND_DAY_AIR") },
		{ code: "Speci-Spec", description: t("UI_TEXT.SPECIAL_INSTRUCTIONS") },
	],
	EUUK: [
		{ code: "UPS-1DA", description: t("UI_TEXT.UPS_NEXT_DAY_AIR") },
		{ code: "UPS-1DM", description: t("SHIPPING.UPS_NEXT_DAY_AIR_AM_DELIVERY") },
		{ code: "UPS-2DA", description: t("SHIPPING.UPS_SECOND_DAY_AIR") },
		{ code: "FedEx-FG", description: t("UI_TEXT.FEDEX_GROUND") },
		{ code: "FedEx-F2", description: t("SHIPPING.FEDEX_SECOND_DAY_AIR") },
		{ code: "Speci-Spec", description: t("UI_TEXT.SPECIAL_INSTRUCTIONS") },
	],
});
const ScheduleOrder = ({ open, setOpen, selectedOrder, source = 'Order History', onScheduleSaved }) => {
	const { selectedSiteCurrency, currencySymbol, selectedSiteData, selectedSite, selectedSiteLegalEnitity } = useSite();
	const [frequency, setFrequency] = useState("");
	const [status, setStatus] = useState("active");
	const [customNumber, setCustomNumber] = useState("");
	const [customUnit, setCustomUnit] = useState("days");
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);
	const [error, setError] = useState("");
	const [notifyBeforeOrder, setNotifyBeforeOrder] = useState(true);
	const [orderProducts, setOrderProducts] = useState([]);
	const { user } = useAuth();
	const [currentStep, setCurrentStep] = useState(0);
	const defaultImage = `${ASSETS_BASE_URL}/stock.png`;
	const navigate = useNavigate();
	const [selectedCustomer, setSelectedCustomer] = useState(null);
	const [shippingAddresses, setShippingAddresses] = useState([]);
	const [billingAddresses, setBillingAddresses] = useState([]);
	const [selectedShippingId, setSelectedShippingId] = useState(null);
	const [selectedBillingId, setSelectedBillingId] = useState(null);
	const [uploadedFile, setUploadedFile] = useState(null);
	const [isExistingPoRemoved, setIsExistingPoRemoved] = useState(false);
	const [isModalLoading, setIsModalLoading] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [isEditing, setIsEditing] = useState({
		shipping: false,
		billing: false,
	});
	const [siteProducts, setSiteProducts] = useState([]);
	const [nonPurchasableInfo, setNonPurchasableInfo] = useState({ total: 0, nonPurchasable: 0 });
	// Add these state variables with your existing useState declarations
	const [dateErrors, setDateErrors] = useState({
		startDate: '',
		endDate: ''
	});
	const datePickerDialogSx = {
		'& .MuiDialog-paper': {
			maxHeight: 'calc(100dvh - 16px)',
			margin: 1,
			display: 'flex',
			flexDirection: 'column',
		},
		'& .MuiDialogContent-root': {
			overflowY: 'auto',
			flex: '1 1 auto',
		}, 
		'& .MuiDialogActions-root': {
			px: 2,
			pb: 2,
			mt: 'auto',
			position: 'sticky',
			bottom: 0,
			backgroundColor: 'background.paper',
			zIndex: 1,
		},
	};
	const datePickerTextFieldSx = {
		'& .MuiFormHelperText-root.Mui-error': {
			color: 'red',
			fontSize: '0.75rem',
		},
	};

	const parsePrice = (price) => {
		const numPrice = typeof price === "string" ? parseFloat(price) : price;
		return isNaN(numPrice) ? 0 : numPrice;
	};

	const { t } = useTranslation();
    const { optionKeys } = useOptions();
	const steps = [t('ORDERS.PART_DETAILS'), t('ORDERS.ORDER_DETAILS'), t('ORDERS.SET_ORDER_FREQUENCY_CONFIRM')];
	const isLastStep = currentStep === steps.length - 1;
	const maxQtyAllowed = useMemo(() => {
		const parsed = parseInt(optionKeys?.maxOrderQty, 10);
		return Number.isFinite(parsed) && parsed > 0 ? parsed : 999;
	}, [optionKeys]);
	const triggerToast = (message, severity = "info") => {
		if (!message) return;
		toast.trigger({ message, severity });
	};

	const getItemMaxQty = (item) => {
		const base = Number(item?.original_quantity || item?.product_quantity || 1);
		if (!Number.isFinite(base) || base <= 0) return maxQtyAllowed;
		return Math.max(maxQtyAllowed, base);
	};

	const DT_BY_LE = useMemo(() => buildDT_BY_LE(t), [t]);
	const DM_BY_LE = useMemo(() => buildDM_BY_LE(t), [t]);

	const isPurchasable = (product) => {
		return !!product;
	};

	const legalEntity = selectedSiteLegalEnitity || "AUSA";
	const deliveryTermsOptions = DT_BY_LE[legalEntity] || DT_BY_LE["AUSA"];
	const deliveryModeOptions = DM_BY_LE[legalEntity] || DM_BY_LE["AUSA"];
	const defaultDeliveryTerm = deliveryTermsOptions[0]?.description || "";
	const defaultModeOfDelivery = deliveryModeOptions[0]?.description || "";

	const orderSummary = useMemo(() => {
		const products = orderProducts.map((item) => ({
			...item,
			price: parsePrice(item.productsData[`price_${selectedSiteCurrency}`]),
		}));

		const subtotal = products.reduce((sum, item) => sum + (item.price * (item.product_quantity || 0)), 0);
		const hasItems = products.some((item) => (item.product_quantity || 0) > 0);

		const taxRate = parseFloat(optionKeys?.taxRate) || 0;
		const shippingCost = hasItems ? parsePrice(optionKeys?.shippingCost) : 0;

		const taxes = subtotal * (taxRate / 100);
		const discount = 0;
		const total = hasItems ? subtotal + taxes - discount + shippingCost : 0;

		return {
			subtotal: hasItems ? subtotal : 0,
			taxes: hasItems ? taxes : 0,
			shipping: hasItems ? shippingCost : 0,
			discounts: hasItems ? discount : 0,
			total: hasItems ? total : 0,
		};
	}, [orderProducts, selectedSiteCurrency, optionKeys]);

	const fetchSiteAddresses = async (type) => {
		if (!selectedSiteData?.site_id) return [];
		try {
			const resp = await getSiteAddressesNew(selectedSiteData.site_id, type);
			let list = resp?.data?.data ?? resp?.data ?? [];

			// Ensure defaults appear first
			list.sort((a, b) => (b.is_default ? 0 : 1) - (a.is_default ? 0 : 1));

			// If API didn't include defaults, synthesize on client
			const hasDefault = list.some((a) => a.is_default);
			if (!hasDefault) {
				if (type === "Shipping" && selectedSiteData) {
					list = [
						{
							id: "default_shipping",
							is_default: true,
							address_type: "Shipping",
							address_name: selectedSiteData.address_name_ln || t('SHIPPING.DEFAULT_SHIPPING'),
							street1: selectedSiteData.street1_ln,
							street2: selectedSiteData.street2_ln,
							street3: selectedSiteData.street3_ln,
							city: selectedSiteData.city_ln,
							state: selectedSiteData.state_ln,
							zip: selectedSiteData.zip_ln,
							country: selectedSiteData.country_ln,
						},
						...list,
					];
				}
				if (type === "Billing" && selectedCustomer) {
					list = [
						{
							id: "default_billing",
							is_default: true,
							address_type: "Billing",
							address_name: selectedCustomer.address_name_cus || t('UI_TEXT.DEFAULT_BILLING'),
							street1: selectedCustomer.street1_cus,
							street2: selectedCustomer.street2_cus,
							street3: selectedCustomer.street3_cus,
							city: selectedCustomer.city_cus,
							state: selectedCustomer.state_cus,
							zip: selectedCustomer.zip_cus,
							country: selectedCustomer.country_cus,
						},
						...list,
					];
				}
			}

			// Add address_full key to each address object
			list = list.map((addr) => {
				const {
					address_name,
					street1,
					street2,
					street3,
					city,
					state,
					zip,
					country,
				} = addr;

				const parts = [address_name, street1, street2, street3, city, state, zip, country]
					.filter(Boolean)
					.join(", ");

				return { ...addr, address_full: parts };
			});

			return list;
		} catch (e) {
			return [];
		}
	};

	const normalizeOrderData = (selectedOrder, selectedSiteCurrency = "usd") => {
		if (!selectedOrder) {
			return {
				shipping_address: {
					name: "",
					street: "",
					city: "",
					zip: "",
					country: "",
					state: "",
				},
				billing_address: {
					name: "",
					street: "",
					city: "",
					zip: "",
					country: "",
					state: "",
				},
				additional_details: {
					delivery_terms: defaultDeliveryTerm,
					ship_complete: t('MENU_ITEMS.NO'),
					mode_of_delivery: defaultModeOfDelivery,
					freight_number: "",
					order_notes: "",
				},
				payment_details: {
					payment_mode: "PO",
					payment_details: {
						po_number: "",
						po_file: "",
						po_filename: "",
					},
				},
				order_details: {
					products: [{
						product_id: "",
						ProductQty: "",
						ProductPrice: "",
						total: "",
					}],
					taxes: "",
					shipping: "",
					discounts: "",
					total: "",
					currency: selectedSiteCurrency,
				},
			};
		}

		// Determine the source type and extract data accordingly
		let normalizedData;

		if (selectedOrder.checkout_details || selectedOrder.checkoutdetails) {
			// Order Schedule format - data is nested under checkout_details
			const checkout = selectedOrder.checkout_details || selectedOrder.checkoutdetails;
			normalizedData = {
				shipping_address: checkout.shipping_address || {},
				billing_address: checkout.billing_address || {},
				additional_details: checkout.additional_details || {},
				payment_details: checkout.payment_details || {},
				order_details: checkout.order_details || checkout.orderdetails || {},
			};
		} else if (selectedOrder.order_id && selectedOrder.products && !selectedOrder.order_details) {
			// Order History format - has order_id, products array, but no nested order_details
			normalizedData = {
				shipping_address: {
					name: selectedOrder?.shipping_name || "",
					street: selectedOrder?.shipping_street || "",
					city: selectedOrder?.shipping_city || "",
					zip: selectedOrder?.shipping_zip || "",
					country: selectedOrder?.shipping_country || "",
					state: selectedOrder?.shipping_state || "",
				},
				billing_address: {
					name: selectedOrder?.billing_name || "",
					street: selectedOrder?.billing_street || "",
					city: selectedOrder?.billing_city || "",
					zip: selectedOrder?.billing_zip || "",
					country: selectedOrder?.billing_country || "",
					state: selectedOrder?.billing_state || "",
				},
				additional_details: {
					delivery_terms: selectedOrder?.delivery_terms || defaultDeliveryTerm,
					ship_complete: selectedOrder?.ship_complete || t('MENU_ITEMS.NO'),
					mode_of_delivery: selectedOrder?.mode_of_delivery || defaultModeOfDelivery,
					freight_number: selectedOrder?.freight_number || "",
					order_notes: selectedOrder?.order_notes || "",
				},
				payment_details: {
					payment_mode: selectedOrder.order_payment_mode || "PO",
					payment_details: {
						po_number:
							(selectedOrder.order_payment_mode || "PO") === "PO"
								? (selectedOrder.order_po || selectedOrder.po_number || "")
								: "",
						po_file:
							(selectedOrder.order_payment_mode || "PO") === "PO"
								? (selectedOrder.po_file_url || selectedOrder.po_file || "")
								: "",
						po_filename:
							(selectedOrder.order_payment_mode || "PO") === "PO"
								? (selectedOrder.po_filename || "")
								: "",
					},
				},
				order_details: {
					products: selectedOrder.products.map(product => ({
						product_id: product.product_id,
						ProductQty: product.product_quantity,
						ProductPrice: product.product_price,
						total: product.product_total,
						// Include the full product data if needed
						productsData: product.productsData,
					})),
					taxes: "", // Not available in order history format
					shipping: "", // Not available in order history format
					discounts: "", // Not available in order history format
					total: selectedOrder.order_total || "",
					currency: selectedOrder.order_currency || selectedSiteCurrency,
				},
			};
		} else {
			// Cart format - already in expected structure
			normalizedData = {
				shipping_address: selectedOrder.shipping_address || {},
				billing_address: selectedOrder.billing_address || {},
				additional_details: selectedOrder.additional_details || {},
				payment_details: selectedOrder.payment_details || {},
				order_details: selectedOrder.order_details || {},
			};
		}

		// Apply defaults for any missing fields
		return {
			shipping_address: {
				name: "",
				street: "",
				city: "",
				zip: "",
				country: "",
				state: "",
				...normalizedData.shipping_address,
			},
			billing_address: {
				name: "",
				street: "",
				city: "",
				zip: "",
				country: "",
				state: "",
				...normalizedData.billing_address,
			},
			additional_details: {
				delivery_terms: defaultDeliveryTerm,
				ship_complete: t('MENU_ITEMS.NO'),
				mode_of_delivery: defaultModeOfDelivery,
				freight_number: "",
				order_notes: "",
				...normalizedData.additional_details,
			},
			payment_details: {
				payment_mode: "PO",
				payment_details: {
					po_number: "",
					po_file: "",
					po_filename: "",
					...(normalizedData.payment_details?.payment_details || {}),
				},
				...normalizedData.payment_details,
			},
			order_details: {
				products: [{
					product_id: "",
					ProductQty: "",
					ProductPrice: "",
					total: "",
				}],
				taxes: "",
				shipping: "",
				discounts: "",
				total: "",
				currency: selectedSiteCurrency,
				...normalizedData.order_details,
			},
		};
	};


	const [checkoutDetails, setCheckoutDetails] = useState(() =>
		normalizeOrderData(selectedOrder, selectedSiteCurrency)
	);

	const [errors, setErrors] = useState({});
	const hasShippingError = Object.keys(errors).some((key) =>
		key.startsWith("shipping_address.")
	);
	const hasBillingError = Object.keys(errors).some((key) =>
		key.startsWith("billing_address.")
	);
	const style = (theme) => ({
		position: "absolute",
		top: "50%",
		left: "50%",
		width: "80vw",
		transform: "translate(-50%, -50%)",
		bgcolor: alpha(theme.palette.background.paper, 1),
		boxShadow: 24,
		borderRadius: 2,
		p: 2,
		px: 6,
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
	});
	const clearSpecificFields = () => {
		setCheckoutDetails(prev => ({
			...prev,
			additional_details: {
				...prev.additional_details,
				freight_number: "",
				order_notes: "",
			},
			payment_details: {
				...prev.payment_details,
				payment_details: {
					...prev.payment_details.payment_details,
					po_number: "",
					po_file: "",
					po_filename: "",
				}
			}
		}));
	};

	const handleCloseDialog = () => {
		setOpen(false);
		setCurrentStep(0);
		setError("");
		setErrors({});
		setFrequency("");
		setStatus("active");
		setCustomNumber("");
		setCustomUnit("days");
		setStartDate(null);
		setEndDate(null);
		setNotifyBeforeOrder(true);
		setOrderProducts([]);
		setDateErrors({
			startDate: '',
			endDate: ''
		});
		setUploadedFile(null);
		setSelectedShippingId(null);
		setSelectedBillingId(null);
		setIsModalLoading(false);
		setIsSubmitting(false);
		setIsExistingPoRemoved(false);
		setIsEditing({
			shipping: false,
			billing: false,
		});

		// Clear only the specific fields you mentioned
		clearSpecificFields();
	};



	useEffect(() => {
		const loadModalData = async () => {
			if (!selectedSiteData?.cus_id || !selectedSite) return;
			setIsModalLoading(true);
			try {
				const [customer_resp, products_resp] = await Promise.all([
					getCustomerByIdForCusSites(selectedSiteData.cus_id),
					getProdutsUniqueBySiteNumber(selectedSite),
				]);

				console.log("inside schedule order getcusbyidforcussites response", customer_resp);
				setSelectedCustomer(customer_resp.data);

				console.log("inside schedule order getproduniquebysiteno response", products_resp);
				const products = products_resp?.data || [];
				if (Array.isArray(products) && products.length) {
					const purchasableProducts = products.filter((product) => isPurchasable(product));
					setSiteProducts(purchasableProducts);
				} else {
					setSiteProducts([]);
				}
			} catch (error) {
				console.log(error);
			} finally {
				setIsModalLoading(false);
			}
		};

		if (open) {
			loadModalData();
		}
	}, [open, selectedSite, selectedSiteData]);

	useEffect(() => {
		const loadAddresses = async () => {
			if (!selectedSiteData?.site_id) return;
			const [shippingList, billingList] = await Promise.all([
				fetchSiteAddresses("Shipping"),
				fetchSiteAddresses("Billing"),
			]);

			setShippingAddresses(shippingList);
			setBillingAddresses(billingList);

			if (!selectedOrder) {
				if (!selectedShippingId && shippingList.length) {
					handleSelectSavedAddress("shipping", shippingList[0]);
				}
				if (!selectedBillingId && billingList.length) {
					handleSelectSavedAddress("billing", billingList[0]);
				}
			}
		};

		loadAddresses();
	}, [selectedSiteData, selectedCustomer, selectedOrder, selectedShippingId, selectedBillingId]);

	useEffect(() => {
		if (!selectedOrder) return;

		if (!selectedShippingId && shippingAddresses.length) {
			const matchId = findMatchingAddressId(
				shippingAddresses,
				checkoutDetails.shipping_address
			);
			if (matchId) setSelectedShippingId(matchId);
		}

		if (!selectedBillingId && billingAddresses.length) {
			const matchId = findMatchingAddressId(
				billingAddresses,
				checkoutDetails.billing_address
			);
			if (matchId) setSelectedBillingId(matchId);
		}
	}, [
		selectedOrder,
		shippingAddresses,
		billingAddresses,
		selectedShippingId,
		selectedBillingId,
		checkoutDetails.shipping_address,
		checkoutDetails.billing_address,
	]);

	useEffect(() => {
		if (selectedOrder && open) {
			const normalizedData = normalizeOrderData(selectedOrder, selectedSiteCurrency);
			setCheckoutDetails(normalizedData);
			setFrequency(selectedOrder?.frequency || "");
			setEndDate(selectedOrder?.end_date ? dayjs(selectedOrder.end_date) : null);
			setStartDate(selectedOrder?.start_date ? dayjs(selectedOrder.start_date) : null);
			if (typeof selectedOrder?.checkout_details?.notify_before_order === "boolean") {
				setNotifyBeforeOrder(selectedOrder.checkout_details.notify_before_order);
			} else if (typeof selectedOrder?.notify_before_order === "boolean") {
				setNotifyBeforeOrder(selectedOrder.notify_before_order);
			} else {
				setNotifyBeforeOrder(true);
			}
			if (selectedOrder?.is_active !== undefined && selectedOrder?.is_active !== null) {
				setStatus(selectedOrder.is_active ? "active" : "inactive");
			} else if (typeof selectedOrder?.status === "string" && selectedOrder.status) {
				const normalizedStatus = selectedOrder.status.toLowerCase();
				setStatus(normalizedStatus === "inactive" ? "inactive" : "active");
			} else {
				setStatus("active");
			}
			setCustomNumber(selectedOrder?.custom_number || "");
			setCustomUnit(selectedOrder?.custom_unit || "days");
			setIsEditing({ shipping: false, billing: false });
			setSelectedShippingId(null);
			setSelectedBillingId(null);
			setUploadedFile(null);
			setIsExistingPoRemoved(false);
		}
	}, [selectedOrder, selectedSiteCurrency, open]);


	useEffect(() => {
		// Re-initialize all values on first load
		console.log("Re-initializing values for new schedule order");
		setFrequency("");
		setStatus("active");
		setCustomNumber("");
		setCustomUnit("days");
		setStartDate(null);
		setEndDate(null);
		setError("");
		setNotifyBeforeOrder(true);
		setOrderProducts([]);
	}, []);

	useEffect(() => {
		if (selectedOrder) return;
		if (!startDate) {
			setEndDate(null);
			setError('');
			return;
		}

		if (frequency === 'custom' || !frequency) {
			setError('');
			return;
		}

		let newEndDate;
		switch (frequency) {
			case 'daily':
				newEndDate = dayjs(startDate).add(1, 'day');
				break;
			case 'weekly':
				newEndDate = dayjs(startDate).add(7, 'day');
				break;
			case 'monthly':
				newEndDate = dayjs(startDate).add(1, 'month');
				break;
			case 'quarterly':
				newEndDate = dayjs(startDate).add(3, 'month');
				break;
			case 'yearly':
				newEndDate = dayjs(startDate).add(1, 'year');
				break;
			default:
				newEndDate = null;
		}

		setEndDate(newEndDate);
		setDateErrors(prev => ({ ...prev, endDate: '' }));
		setError('');

		if (newEndDate) {
			setTimeout(() => {
				validateDates(startDate, newEndDate);
			}, 0);
		}
	}, [frequency, startDate]);

	useEffect(() => {
		if (selectedOrder && open && selectedOrder.products) {
			const uniqueProducts = selectedOrder.products.filter(
				(item, index, self) => index === self.findIndex((p) => p.product_id === item.product_id)
			);
			const purchasableProducts = uniqueProducts
				.filter((item) => isPurchasable(item?.productsData ?? item))
				.map((item) => ({
					...item,
					original_quantity: item?.original_quantity ?? item?.product_quantity ?? 1,
				}));
			setOrderProducts(purchasableProducts);
			setNonPurchasableInfo({
				total: uniqueProducts.length,
				nonPurchasable: uniqueProducts.length - purchasableProducts.length,
			});
			setError("");
		} else {
			setNonPurchasableInfo({ total: 0, nonPurchasable: 0 });
		}
	}, [selectedOrder, open]);

	const toggleEdit = (section) => {
		setIsEditing((prev) => ({
			...prev,
			[section]: !prev[section],
		}));
	};

	const handleSelectSavedAddress = (section, address) => {
		if (!address) {
			if (section === "shipping") setSelectedShippingId(null);
			if (section === "billing") setSelectedBillingId(null);
			return;
		}

		const normalized = {
			name: address.address_name || "",
			street: [address.street1, address.street2, address.street3].filter(Boolean).join(" "),
			city: address.city || "",
			state: address.state || "",
			zip: address.zip || "",
			country: address.country || "",
		};

		if (section === "shipping") {
			setSelectedShippingId(address.id);
		} else {
			setSelectedBillingId(address.id);
		}

		setCheckoutDetails((prev) => ({
			...prev,
			[`${section}_address`]: normalized,
		}));
	};

	const handleInputChange = (section, field, value) => {
		setCheckoutDetails((prev) => ({
			...prev,
			[section]: {
				...prev[section],
				[field]: value,
			},
		}));
	};

	const handlePaymentModeChange = (event) => {
		const value = event.target.value;
		setCheckoutDetails((prev) => ({
			...prev,
			payment_details: {
				...prev.payment_details,
				payment_mode: value,
				payment_details: {
					...prev.payment_details.payment_details,
					po_number: value === "PO" ? prev.payment_details.payment_details.po_number : "",
				},
			},
		}));
	};

	const handleFileUpload = (event) => {
		const file = event.target.files[0];
		if (!file) return;

		const allowedTypes = [
			"application/pdf",
			"image/jpeg",
			"image/png",
			"application/msword",
			"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
		];
		const maxFileSize = 10 * 1024 * 1024; // 10MB

		if (!allowedTypes.includes(file.type)) {
			Swal.fire({
				icon: "error",
				title: t("ALERT_MESSAGES.INVALID_FILE_TYPE_TITLE"),
				text: t("ALERT_MESSAGES.INVALID_FILE_TYPE_TEXT"),
			});
			return;
		}

		if (file.size > maxFileSize) {
			Swal.fire({
				icon: "error",
				title: t("ALERT_MESSAGES.FILE_TOO_LARGE_TITLE"),
				text: t("ALERT_MESSAGES.FILE_TOO_LARGE_TEXT"),
			});
			return;
		}

		setUploadedFile(file);
		setIsExistingPoRemoved(false);
		event.target.value = null;
	};

	const handleDeleteFile = () => {
		setUploadedFile(null);
	};

	const handleRemoveExistingPoFile = () => {
		setCheckoutDetails((prev) => ({
			...prev,
			payment_details: {
				...prev.payment_details,
				payment_details: {
					...prev.payment_details.payment_details,
					po_file: "",
					po_filename: "",
				},
			},
		}));
		setIsExistingPoRemoved(true);
	};

	const normalizeAddressFields = (address = {}) => ({
		name: (address.name || "").toString().trim().toLowerCase(),
		street: (address.street || "").toString().trim().toLowerCase(),
		city: (address.city || "").toString().trim().toLowerCase(),
		state: (address.state || "").toString().trim().toLowerCase(),
		zip: (address.zip || "").toString().trim().toLowerCase(),
		country: (address.country || "").toString().trim().toLowerCase(),
	});

	const findMatchingAddressId = (addresses, targetAddress) => {
		if (!Array.isArray(addresses) || !targetAddress) return null;

		const target = normalizeAddressFields(targetAddress);

		const match = addresses.find((address) => {
			const normalized = normalizeAddressFields({
				name: address.address_name,
				street: [address.street1, address.street2, address.street3].filter(Boolean).join(" "),
				city: address.city,
				state: address.state,
				zip: address.zip,
				country: address.country,
			});

			return (
				normalized.name === target.name &&
				normalized.street === target.street &&
				normalized.city === target.city &&
				normalized.state === target.state &&
				normalized.zip === target.zip &&
				normalized.country === target.country
			);
		});

		if (match?.id) return match.id;

		const fallback = addresses.find((address) => {
			const normalized = normalizeAddressFields({
				street: [address.street1, address.street2, address.street3].filter(Boolean).join(" "),
				city: address.city,
				state: address.state,
				zip: address.zip,
				country: address.country,
			});

			return (
				normalized.street === target.street &&
				normalized.city === target.city &&
				normalized.state === target.state &&
				normalized.zip === target.zip &&
				normalized.country === target.country
			);
		});

		return fallback?.id || null;
	};

	const handleFieldChange = (section, field, value) => {
		setCheckoutDetails((prevDetails) => updateNestedField(prevDetails, [section, ...field.split(".")], value));
	};

	const updateNestedField = (obj, keys, value) => {
		const [currentKey, ...remainingKeys] = keys;

		if (!remainingKeys.length) {
			return {
				...obj,
				[currentKey]: value,
			};
		}

		return {
			...obj,
			[currentKey]: updateNestedField(obj[currentKey] || {}, remainingKeys, value),
		};
	};

	const validateAddress = (address, fieldPrefix) => {
		const newErrors = {};

		if (!address.name) newErrors[`${fieldPrefix}.name`] = t('UI_TEXT.NAME_REQUIRED');
		if (!address.street) newErrors[`${fieldPrefix}.street`] = t('UI_TEXT.STREET_REQUIRED');
		if (!address.city) newErrors[`${fieldPrefix}.city`] = t('UI_TEXT.CITY_REQUIRED');
		if (!address.zip) newErrors[`${fieldPrefix}.zip`] = t('UI_TEXT.ZIPCODE_REQUIRED');
		if (!address.country) newErrors[`${fieldPrefix}.country`] = t('UI_TEXT.COUNTRY_REQUIRED');
		if (!address.state) newErrors[`${fieldPrefix}.state`] = t('UI_TEXT.STATE_REQUIRED');

		setErrors((prevErrors) => ({ ...prevErrors, ...newErrors }));
		return Object.keys(newErrors).length === 0;
	};

	const validateAdditionalOrderDetails = () => {
		const { delivery_terms, ship_complete, mode_of_delivery } = checkoutDetails.additional_details;
		const newErrors = {};

		if (!delivery_terms) newErrors["additional_details.delivery_terms"] = t('UI_TEXT.DELIVERY_TERMS_REQUIRED');
		if (!ship_complete) newErrors["additional_details.ship_complete"] = t('UI_TEXT.SHIP_REQUIRED');
		if (!mode_of_delivery) newErrors["additional_details.mode_of_delivery"] = t('UI_TEXT.MODE_OF_DELIVERY_REQUIRED');

		setErrors((prevErrors) => ({ ...prevErrors, ...newErrors }));
		return Object.keys(newErrors).length === 0;
	};

	const validatePaymentDetails = () => {
		setErrors((prevErrors) => {
			const nextErrors = { ...prevErrors };
			delete nextErrors["payment_details.payment_details.po_number"];
			return nextErrors;
		});
		return true;
	};


	const handleNext = () => {
		if (currentStep === 0) {
			if (orderProducts.length === 0) {
				setError(t('ALERT_MESSAGES.PLEASE_ADD_ONE_PRODUCT'));
				return;
			} else {
				setError("");
			}
		} else if (currentStep === 1) {
			const isShippingValid = validateAddress(checkoutDetails.shipping_address, "shipping_address");
			const isBillingValid = validateAddress(checkoutDetails.billing_address, "billing_address");
			const areAdditionalDetailsValid = validateAdditionalOrderDetails();
			const arePaymentDetailsValid = validatePaymentDetails();

			if (!isShippingValid || !isBillingValid || !areAdditionalDetailsValid || !arePaymentDetailsValid) {
				setError(t('ALERT_MESSAGES.PLEASE_FILL_REQUIRED_FIELDS'));
				return;
			} else {
				setError("");
			}
		} else if (currentStep === 2) {
			const products = orderProducts.map((item) => ({
				product_id: item.Product.product_id,
				product_name: item.Product.product_name,
				product_number: item.Product.product_number,
				ProductQty: item.Quantity,
				ProductPrice: item.Product[`price_${selectedSiteCurrency}`],
				total: (item.Quantity * parseFloat(item.Product[`price_${selectedSiteCurrency}`])).toFixed(2),
			}));
		}

		if (!isLastStep) {
			setCurrentStep((prev) => prev + 1);
		}
	};

	const handleBack = () => {
		if (currentStep > 0) {
			setCurrentStep((prev) => prev - 1);
		}
	};

	const handleError = (e) => {
		e.target.onerror = null; // Prevent infinite loop
		e.target.src = defaultImage;
	};
	const handleNavigateToProduct = (url) => {
		navigate(url);
	};

	const handleUpdateQuantity = (productId, change) => {
		setOrderProducts((prevData) =>
			prevData.map((item) =>
				item.product_id === productId
					? {
						...item,
						product_quantity: (() => {
							const maxAllowed = getItemMaxQty(item);
							const next = item.product_quantity + change;
							const clamped = Math.max(1, Math.min(maxAllowed, next));
							if (next > maxAllowed) {
								triggerToast(t('ALERT_MESSAGES.QUANTITY_ADJUSTED_TO_MAX', { maxStock: maxAllowed }), "warning");
							}
							return clamped;
						})(),
					}
					: item
			)
		);
	};

	const handleQuantityChange = (productId, newValue) => {
		const numericValue = parseInt(newValue);
		if (!isNaN(numericValue)) {
			const clamped = Math.max(1, Math.min(maxQtyAllowed, numericValue));
			setOrderProducts((prevData) =>
				prevData.map((item) =>
					item.product_id === productId ? {
						...item,
						product_quantity: (() => {
							const maxAllowed = getItemMaxQty(item);
							const next = Math.max(1, Math.min(maxAllowed, numericValue));
							if (numericValue > maxAllowed) {
								triggerToast(t('ALERT_MESSAGES.QUANTITY_ADJUSTED_TO_MAX', { maxStock: maxAllowed }), "warning");
							}
							return next;
						})(),
					} : item
				)
			);
		}
	};

	const handleBlur = (productId) => {
		setOrderProducts((prevData) =>
			prevData.map((item) =>
				item.product_id === productId
					? {
						...item,
						product_quantity: (() => {
							const maxAllowed = getItemMaxQty(item);
							const parsed = parseInt(item.product_quantity) || 1;
							const next = Math.max(1, Math.min(maxAllowed, parsed));
							if (parsed > maxAllowed) {
								triggerToast(t('ALERT_MESSAGES.QUANTITY_ADJUSTED_TO_MAX', { maxStock: maxAllowed }), "warning");
							}
							return next;
						})(),
					}
					: item
			)
		);
	};

	const handleRemoveItem = (productId) => {
		setOrderProducts((prevData) => prevData.filter((item) => item.product_id !== productId));
	};

	// Handle manual endDate change
	// Replace your existing handleEndDateChange with this
	const handleEndDateChange = (newValue) => {
		setEndDate(newValue);

		// Clear any previous errors when user changes date
		setDateErrors(prev => ({ ...prev, endDate: '' }));

		// Validate after setting the new value
		setTimeout(() => {
			validateDates(startDate, newValue);
		}, 0);
	};

	// Also update start date handler
	const handleStartDateChange = (newValue) => {
		setStartDate(newValue);

		// Clear any previous errors when user changes date
		setDateErrors(prev => ({ ...prev, startDate: '' }));

		// Validate after setting the new value
		setTimeout(() => {
			validateDates(newValue, endDate);
		}, 0);
	};


	const handleFrequencyChange = (event) => {
		setFrequency(event.target.value);
		if (event.target.value !== "custom") {
			setCustomNumber("");
			setCustomUnit("days");
		}
	};



	const handleSetSchedule = async () => {
		setIsSubmitting(true);
		// Validate dates before submission
		const areDatesValid = validateDates(startDate, endDate);

		if (!startDate || !endDate || !frequency) {
			setError(t('ALERT_MESSAGES.PLEASE_FILL_REQUIRED_FILEDS_BEFORE_SCHEDULE'));
			setIsSubmitting(false);
			return;
		}
		if (!areDatesValid) {
			setError("Please fix the date validation errors before proceeding.");
			setIsSubmitting(false);
			return;
		}

		let base64File = "";
		let fileName = "";
		if (uploadedFile) {
			try {
				const file = uploadedFile;
				fileName = file.name;
				const reader = new FileReader();
				base64File = await new Promise((resolve, reject) => {
					reader.onload = () => resolve(reader.result.split(",")[1]);
					reader.onerror = reject;
					reader.readAsDataURL(file);
				});
			} catch (error) {
				console.error("Error converting file to base64:", error);
				Swal.fire({
					icon: "error",
					title: "Error",
					text: t('UI_TEXT.ERROR_PROCESSING_UPLOADED_FILE_PLEASE_TRY_AGAIN'),
				});
				setIsSubmitting(false);
				return;
			}
		}
		const products = orderProducts.map((item) => ({
			product_id: item.product_id,
			ProductQty: item.product_quantity,
			ProductPrice: parsePrice(item.productsData[`price_${selectedSiteCurrency}`]).toFixed(2),
			total: (parsePrice(item.productsData[`price_${selectedSiteCurrency}`]) * item.product_quantity).toFixed(2),
		}));

		const productTotal = products.reduce((total, item) => total + parseFloat(item.total), 0);
		const taxRate = parseFloat(optionKeys?.taxRate) || 0;
		const taxes = (productTotal * (taxRate / 100)).toFixed(2);
		const discount = 0;
		const shipping = parsePrice(optionKeys?.shippingCost);
		const total = (productTotal + parseFloat(taxes) - parseFloat(discount) + shipping).toFixed(2);

		const newCheckoutDetails = {
			shipping_address: checkoutDetails.shipping_address,
			billing_address: checkoutDetails.billing_address,
			additional_details: checkoutDetails.additional_details,
			notify_before_order: notifyBeforeOrder,
			payment_details: {
				payment_mode: checkoutDetails.payment_details.payment_mode,
				payment_details: {
					po_number: checkoutDetails.payment_details.payment_details.po_number,
					po_file: base64File || (isExistingPoRemoved ? "" : checkoutDetails.payment_details.payment_details.po_file),
					po_filename: fileName || (isExistingPoRemoved ? "" : checkoutDetails.payment_details.payment_details.po_filename),
				},
			},
			order_details: {
				products: products,
				taxes: taxes,
				shipping: shipping,
				discounts: discount,
				total: total,
			},
			selectedSite: selectedSiteData.site_id,
			cus_id: selectedSiteData.cus_id,
			loggedin_user: user.user_id,
			loggedin_user_email: user.user_email,
			loggedin_user_name: user.user_first_name + " " + user.user_last_name,
			loggedin_user_phone: user.user_phone || "",
		};

		const req_body = {
			frequency,
			start_date: startDate,
			end_date: endDate,
			is_active: status === "active" ? true : false,
			notify_before_order: notifyBeforeOrder,
			origin: source,
			origin_id: selectedOrder?.order_id || 0,
			user_id: user.user_id,
			custom_number: customNumber,
			custom_unit: customUnit,
			site_id: selectedSiteData.site_id,
			checkout_details: newCheckoutDetails,
		};


		try {
			let response;
			if (selectedOrder && selectedOrder.job_id) {
				// If selectedOrder is not null and has a job_id, then its a job which exists
				req_body.job_id = selectedOrder.job_id;
				req_body.id = selectedOrder.id;
				response = await scheduleUpdate(req_body);
			} else {
				response = await schedule(req_body);
			}
			if (response.status) {
				const message = selectedOrder && selectedOrder.job_id
					? t('ALERT_MESSAGES.SCHEDULE_UPDATED_SUCCESSFULLY')
					: t('ALERT_MESSAGES.SCHEDULE_SET_SUCCESSFULLY');
				toast.trigger({ message, severity: "success" });
				if (onScheduleSaved) {
					await onScheduleSaved();
				}
				handleCloseDialog();
				setCheckoutDetails({
					shipping_address: checkoutDetails.shipping_address,
					billing_address: checkoutDetails.billing_address,
					additional_details: {
						delivery_terms: "UI_TEXT.PREPAID_AND_ADD",
						ship_complete: t('MENU_ITEMS.NO'),
						mode_of_delivery: "UPS Ground",
						freight_number: "",
						order_notes: "",
					},
					payment_details: {
						payment_mode: "PO",
						payment_details: {
							po_number: "",
							po_file: "",
							po_filename: "",
						},
					},
					order_details: {
						products: [
							{
								product_id: "",
								ProductQty: "",
								ProductPrice: "",
								total: "",
							},
						],
						taxes: "",
						shipping: "",
						discounts: "",
						total: "",
						currency: selectedSiteCurrency || "usd",
					},
				});
				setFrequency("");
				setStatus("active");
				setCustomNumber("");
				setCustomUnit("days");
				setStartDate(null);
				setEndDate(null);
				setError("");
				setNotifyBeforeOrder(true);
				setOrderProducts([]);
				setUploadedFile(null);
			}
		} catch (error) {
			console.error("Error setting schedule: ", error);
			setError("Failed to set schedule. Please try again.");
			setIsSubmitting(false);
			return;
		}

		setIsSubmitting(false);

		// If validation passes
	};

	const renderStep = (step) => {
		const existingPoFilename = checkoutDetails?.payment_details?.payment_details?.po_filename;
		const existingPoFile = checkoutDetails?.payment_details?.payment_details?.po_file;
		const showExistingPoFile = !uploadedFile && !isExistingPoRemoved && (existingPoFilename || existingPoFile);
		switch (step) {
			case 1:
				return (
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "flex-start",
							alignItems: "flex-start",
							mb: 2,
							mt: 1,
							rowGap: "10px",
							flexWrap: "nowrap",
							height: "55vh",
							minHeight: "55vh",
							maxHeight: "55vh",
							width: "100%",
							overflowY: "auto",
						}}>
						<Typography variant="body1" fontWeight={"bold"}>
							{t('UI_TEXT.SHIPPING_BILLING_ADDRESS')}
						</Typography>

						<Box
							sx={{
								width: "100%",
								display: "flex",
								flexDirection: { xs: "column", md: "row" },
								justifyContent: "space-between",
								alignItems: "flex-start",
								columnGap: "15px",
								p: 2,
								rowGap: "10px",
							}}>
							<Box
								sx={{
									width: { xs: "100%", md: "48%" },
									borderRadius: "10px",
									...(hasShippingError
										? {
											borderColor: "error.main",
											borderWidth: 1,
											borderStyle: "solid",
										}
										: {
											borderColor: "#e5e7eb",
											borderWidth: 1,
											borderStyle: "solid",
										}),
									p: 2,
								}}
							>
								<Box display="flex" justifyContent="space-between" alignItems="center">
									<Typography variant="h6" sx={{ fontWeight: "bold" }}>
										{t('UI_TEXT.SHIPPING_ADDRESS')}
									</Typography>
									<IconButton
										onClick={() => toggleEdit("shipping")}
										color={isEditing.shipping ? "primary" : ""}>
										{isEditing.shipping ? (
											<Tooltip title={t("UI_TEXT.TOOLTIP_SAVE_ADDRESS")} arrow placement="top">
												<Check />
											</Tooltip>
										) : (
											<Tooltip title={t("UI_TEXT.TOOLTIP_EDIT_ADDRESS")} arrow placement="top">
													<EditIcon />
											</Tooltip>
										)}
									</IconButton>
								</Box>
								{isEditing.shipping ? (
									<Box mt={2}>
										<Autocomplete
											fullWidth
											size="small"
											options={shippingAddresses}
											getOptionLabel={(option) => option.address_name || ''}
											value={shippingAddresses.find((addr) => String(addr.id) === String(selectedShippingId)) || null}
											onChange={(event, newValue) =>
												handleSelectSavedAddress("shipping", newValue || null)
											}
											renderInput={(params) => (
												<TextField {...params} label="Select Saved Address" variant="outlined" />
											)}
											renderOption={(props, option) => (
												<li {...props} key={option.id}>
													<Box>
														<Typography variant="body1">{option.address_name}</Typography>
														<Typography
															variant="body2"
															color="text.secondary"
															fontStyle="italic"
															fontSize="11px"
														>
															<b>{t('LABELS.ADDRESS')}: </b>{option.address_full}
														</Typography>
													</Box>
												</li>
											)}
										/>
										<Divider sx={{ my: 2 }} />
										<TextField
											required
											label={t('LABELS.NAME')}
											size="small"
											fullWidth
											value={checkoutDetails.shipping_address.name}
											error={!!errors["shipping_address.name"]}
											onChange={(e) =>
												handleInputChange("shipping_address", "name", e.target.value)
											}
											onBlur={() => {
												validateAddress(checkoutDetails.shipping_address, "shipping_address");
											}}
											sx={{ mb: 2 }}
										/>
										<TextField
											label={t('LABELS.STREET')}
											required
											size="small"
											fullWidth
											value={checkoutDetails.shipping_address.street}
											error={!!errors["shipping_address.street"]}
											onChange={(e) =>
												handleInputChange("shipping_address", "street", e.target.value)
											}
											onBlur={() => {
												validateAddress(checkoutDetails.shipping_address, "shipping_address");
											}}
											sx={{ mb: 2 }}
										/>
										<TextField
											label={t('LABELS.CITY')}
											size="small"
											fullWidth
											required
											value={checkoutDetails.shipping_address.city}
											error={!!errors["shipping_address.city"]}
											onChange={(e) =>
												handleInputChange("shipping_address", "city", e.target.value)
											}
											onBlur={() => {
												validateAddress(checkoutDetails.shipping_address, "shipping_address");
											}}
											sx={{ mb: 2 }}
										/>
										<TextField
											label={t('LABELS.STATE')}
											size="small"
											fullWidth
											required
											value={checkoutDetails.shipping_address.state}
											error={!!errors["shipping_address.state"]}
											onChange={(e) =>
												handleInputChange("shipping_address", "state", e.target.value)
											}
											onBlur={() => {
												validateAddress(checkoutDetails.shipping_address, "shipping_address");
											}}
											sx={{ mb: 2 }}
										/>
										<TextField
											label={t('LABELS.ZIP')}
											size="small"
											required
											fullWidth
											value={checkoutDetails.shipping_address.zip}
											error={!!errors["shipping_address.zip"]}
											onChange={(e) =>
												handleInputChange("shipping_address", "zip", e.target.value)
											}
											onBlur={() => {
												validateAddress(checkoutDetails.shipping_address, "shipping_address");
											}}
											sx={{ mb: 2 }}
										/>
										<TextField
											label={t('LABELS.COUNTRY')}
											size="small"
											required
											fullWidth
											value={checkoutDetails.shipping_address.country}
											error={!!errors["shipping_address.country"]}
											onChange={(e) =>
												handleInputChange("shipping_address", "country", e.target.value)
											}
											onBlur={() => {
												validateAddress(checkoutDetails.shipping_address, "shipping_address");
											}}
											sx={{ mb: 2 }}
										/>
									</Box>
								) : (
										<Box>
											<Typography
												variant="body1"
												color={errors["shipping_address.name"] ? "error" : "inherit"}
											>
												{checkoutDetails.shipping_address.name?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["shipping_address.street"] ? "error" : "inherit"}
											>
												{checkoutDetails.shipping_address.street?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["shipping_address.city"] ? "error" : "inherit"}
											>
												{checkoutDetails.shipping_address.city?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["shipping_address.state"] ? "error" : "inherit"}
											>
												{checkoutDetails.shipping_address.state?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["shipping_address.zip"] ? "error" : "inherit"}
											>
												{checkoutDetails.shipping_address.zip?.trim() || "—"}
											</Typography>
										<Typography
											variant="body1"
											color={errors["shipping_address.country"] ? "error" : "inherit"}
										>
											{checkoutDetails.shipping_address.country?.trim() || "—"}
										</Typography>
									</Box>
								)}
							</Box>

							{/* Billing Address Card */}
							<Box
								sx={{
									width: { xs: "100%", md: "48%" },
									borderRadius: "10px",
									...(hasBillingError
										? {
											borderColor: "error.main",
											borderWidth: 1,
											borderStyle: "solid",
										}
										: {
											borderColor: "#e5e7eb",
											borderWidth: 1,
											borderStyle: "solid",
										}),
									p: 2,
								}}
							>
								<Box display="flex" justifyContent="space-between" alignItems="center">
									<Typography variant="h6" sx={{ fontWeight: "bold" }}>
										{t('UI_TEXT.BILLING_ADDRESS')}
									</Typography>
									<IconButton
										onClick={() => toggleEdit("billing")}
										color={isEditing.billing ? "primary" : ""}>
										{isEditing.billing ? (
											<Tooltip title={t("UI_TEXT.TOOLTIP_SAVE_ADDRESS")} arrow placement="top">
												<Check />
											</Tooltip>
										) : (
											<Tooltip title={t("UI_TEXT.TOOLTIP_EDIT_ADDRESS")} arrow placement="top">
													<EditIcon />
											</Tooltip>
										)}
									</IconButton>
								</Box>
								{isEditing.billing ? (
									<Box mt={2}>
										<Autocomplete
											fullWidth
											size="small"
											options={billingAddresses}
											getOptionLabel={(option) => option.address_name || ''}
											value={billingAddresses.find((addr) => String(addr.id) === String(selectedBillingId)) || null}
											onChange={(event, newValue) =>
												handleSelectSavedAddress("billing", newValue || null)
											}
											renderInput={(params) => (
												<TextField {...params} label="Select Saved Address" variant="outlined" />
											)}
											renderOption={(props, option) => (
												<li {...props} key={option.id}>
													<Box>
														<Typography variant="body1">{option.address_name}</Typography>
														<Typography
															variant="body2"
															color="text.secondary"
															fontStyle="italic"
															fontSize="11px"
														>
															<b>{t('LABELS.ADDRESS')}: </b>{option.address_full}
														</Typography>
													</Box>
												</li>
											)}
										/>
										<Divider sx={{ my: 2 }} />
										<TextField
											label={t('LABELS.NAME')}
											size="small"
											required
											fullWidth
											value={checkoutDetails.billing_address.name}
											error={!!errors["billing_address.name"]}
											onChange={(e) =>
												handleInputChange("billing_address", "name", e.target.value)
											}
											onBlur={() => {
												validateAddress(checkoutDetails.billing_address, "billing_address");
											}}
											sx={{ mb: 2 }}
										/>
										<TextField
											label={t('LABELS.STREET')}
											size="small"
											fullWidth
											required
											value={checkoutDetails.billing_address.street}
											error={!!errors["billing_address.street"]}
											onChange={(e) =>
												handleInputChange("billing_address", "street", e.target.value)
											}
											onBlur={() => {
												validateAddress(checkoutDetails.billing_address, "billing_address");
											}}
											sx={{ mb: 2 }}
										/>
										<TextField
											label={t('LABELS.CITY')}
											size="small"
											fullWidth
											required
											value={checkoutDetails.billing_address.city}
											error={!!errors["billing_address.city"]}
											onChange={(e) =>
												handleInputChange("billing_address", "city", e.target.value)
											}
											onBlur={() => {
												validateAddress(checkoutDetails.billing_address, "billing_address");
											}}
											sx={{ mb: 2 }}
										/>
										<TextField
											label={t('LABELS.STATE')}
											size="small"
											fullWidth
											required
											value={checkoutDetails.billing_address.state}
											error={!!errors["billing_address.state"]}
											onChange={(e) =>
												handleInputChange("billing_address", "state", e.target.value)
											}
											onBlur={() => {
												validateAddress(checkoutDetails.billing_address, "billing_address");
											}}
											sx={{ mb: 2 }}
										/>
										<TextField
											label={t('LABELS.ZIP')}
											size="small"
											fullWidth
											required
											value={checkoutDetails.billing_address.zip}
											error={!!errors["billing_address.zip"]}
											onChange={(e) =>
												handleInputChange("billing_address", "zip", e.target.value)
											}
											onBlur={() => {
												validateAddress(checkoutDetails.billing_address, "billing_address");
											}}
											sx={{ mb: 2 }}
										/>
										<TextField
											label={t('LABELS.COUNTRY')}
											size="small"
											fullWidth
											required
											value={checkoutDetails.billing_address.country}
											error={!!errors["billing_address.country"]}
											onChange={(e) =>
												handleInputChange("billing_address", "country", e.target.value)
											}
											onBlur={() => {
												validateAddress(checkoutDetails.billing_address, "billing_address");
											}}
											sx={{ mb: 2 }}
										/>
									</Box>
								) : (
										<Box>
											<Typography
												variant="body1"
												color={errors["billing_address.name"] ? "error" : "inherit"}
											>
												{checkoutDetails.billing_address.name?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["billing_address.street"] ? "error" : "inherit"}
											>
												{checkoutDetails.billing_address.street?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["billing_address.city"] ? "error" : "inherit"}
											>
												{checkoutDetails.billing_address.city?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["billing_address.state"] ? "error" : "inherit"}
											>
												{checkoutDetails.billing_address.state?.trim() || "—"}
											</Typography>
											<Typography
												variant="body1"
												color={errors["billing_address.zip"] ? "error" : "inherit"}
											>
												{checkoutDetails.billing_address.zip?.trim() || "—"}
											</Typography>
										<Typography
											variant="body1"
											color={errors["billing_address.country"] ? "error" : "inherit"}
										>
											{checkoutDetails.billing_address.country?.trim() || "—"}
										</Typography>
									</Box>
								)}
							</Box>
						</Box>

						<Typography variant="body1" fontWeight={"bold"}>
							{t('UI_TEXT.ADDITIONAL_ORDER_DETAILS')}
						</Typography>

						<Box sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%", p: 2 }}>
							<Box sx={{ display: "flex", gap: 2 }}>
								<FormControl fullWidth required>
									<InputLabel>{t('UI_TEXT.DELIVERY_TERMS')}</InputLabel>
									<Select
										size="small"
										value={checkoutDetails.additional_details.delivery_terms}
										error={!!errors["additional_details.delivery_terms"]}
										label={t('UI_TEXT.DELIVERY_TERMS')}
										onChange={(e) =>
											handleFieldChange("additional_details", "delivery_terms", e.target.value)
										}>
										{deliveryTermsOptions.map((opt) => (
											<MenuItem key={opt.term} value={opt.description}>
												{opt.description}
											</MenuItem>
										))}
									</Select>
								</FormControl>
								<FormControl fullWidth required>
									<InputLabel>{t('UI_TEXT.SHIP_COMPLETE')}</InputLabel>
									<Select
										size="small"
										value={checkoutDetails.additional_details.ship_complete}
										error={!!errors["additional_details.ship_complete"]}
										label={t('UI_TEXT.SHIP_COMPLETE')}
										onChange={(e) =>
											handleFieldChange("additional_details", "ship_complete", e.target.value)
										}>
										<MenuItem value="Yes">{t('MENU_ITEMS.YES')}</MenuItem>
										<MenuItem value= {t('MENU_ITEMS.NO')}>{t('MENU_ITEMS.NO')}</MenuItem>
									</Select>
								</FormControl>
							</Box>

							<Box sx={{ display: "flex", gap: 2 }}>
								<FormControl fullWidth required>
									<InputLabel>{t('UI_TEXT.MODE_OF_DELIVERY')}</InputLabel>
									<Select
										size="small"
										value={checkoutDetails.additional_details.mode_of_delivery}
										error={!!errors["additional_details.mode_of_delivery"]}
										label={t('UI_TEXT.MODE_OF_DELIVERY')}
										onChange={(e) =>
											handleFieldChange("additional_details", "mode_of_delivery", e.target.value)
										}>
										{deliveryModeOptions.map((opt) => (
											<MenuItem key={opt.code} value={opt.description}>
												{opt.description}
											</MenuItem>
										))}
									</Select>
								</FormControl>
								<TextField
									fullWidth
									size="small"
									label={t('UI_TEXT.FREIGHT_NUMBER')}
									value={checkoutDetails.additional_details.freight_number}
									onChange={(e) =>
										handleFieldChange("additional_details", "freight_number", e.target.value)
									}
									placeholder={t('PLACEHOLDER.ENTER_FREIGHT_NUMBER')}
								/>
							</Box>

							<TextField
								fullWidth
								size="small"
								label={t('UI_TEXT.ORDER_NOTES')}
								multiline
								rows={4}
								value={checkoutDetails.additional_details.order_notes}
								onChange={(e) => handleFieldChange("additional_details", "order_notes", e.target.value)}
								placeholder={t('PLACEHOLDER.ENTER_ORDER_NOTES')}
							/>
						</Box>

						{/* Payment details hidden for scheduled quote flow. */}
					</Box>
				);
			case 0:
				return (
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "flex-start",
							alignItems: "flex-start",
							mb: 2,
							mt: 1,
							rowGap: "10px",
							width: "100%",
							flex: 1,
							height: "100%",
							maxHeight: "55vh",
							minHeight: "55vh",
							overflowY: "auto",
						}}>
						<Typography variant="body1" fontWeight={"bold"}>
							{t('UI_TEXT.PART_DETAILS')}
						</Typography>
						{nonPurchasableInfo.nonPurchasable > 0 && (
							<Alert severity="info" sx={{ width: "100%" }}>
								{t('ORDERS.NON_PURCHASABLE_PARTS_INFO').replace('{nonPurchasable}', nonPurchasableInfo.nonPurchasable).replace('{total}', nonPurchasableInfo.total)}
							</Alert>
						)}

						<Autocomplete
							multiple
							size="small"
							options={siteProducts}
							value={orderProducts}
							sx={{ width: "100%", mb: 1 }}
							onChange={(event, newValue) => {
								setOrderProducts((prev) =>
									newValue.map((product) => {
										const existing = prev.find((item) => item.product_id === product.product_id);

										const price = product[`price_${selectedSiteCurrency}`] || product.product_sell_price || 0;

										return existing || {
											id: null,
											order_id: selectedOrder || null,
											product_id: product.product_id,
											product_quantity: 1,
											product_price: price,
											product_total: price * 1,
											productsData: product
										};
									})
								);
							}}
							getOptionLabel={(option) => {
								if (typeof option === 'string') return option;
								if (!option) return '';

								// If it's a product from siteProducts
								if (option.product_name) return option.product_name;
								if (option.product_number) return option.product_number;

								// If it's an orderProduct object
								if (option.productsData) return option.productsData.product_name || option.productsData.product_number || '';

								return '';
							}}
							isOptionEqualToValue={(option, value) => option.product_id === value.product_id}
							renderTags={(value) => {
								if (!value?.length) return null;
								const label = value.length === 1 ? t('ORDERS.ONE_PART_SELECTED') : t('ORDERS.PARTS_SELECTED').replace('{count}', value.length);
								return [
									<Chip
										key="parts-count"
										label={label}
										size="small"
										onDelete={() => setOrderProducts([])}
									/>
								];
							}}
							renderInput={(params) => (
								<TextField {...params} label={t('ORDERS.SELECT_PRODUCTS')} size="small" />
							)}
						/>
						<Box
							sx={{
								flexGrow: 1,
								overflowY: "auto",
								minHeight: '200px',
								p: 1,
								width: '100%'
							}}
						>


							<TableContainer sx={{ width: '100%' }}>
							<Table>
								<TableHead>
									<TableRow>
										<TableCell>{t('TABLE_HEADERS.PARTS_QUANTITY')}</TableCell>
										<TableCell align="center">{t('TABLE_HEADERS.QUANTITY')}</TableCell>
										{/* <TableCell align="right">{t('TABLE_HEADERS.PRICE')}</TableCell> */}
										{/* <TableCell align="right">{t('TABLE_HEADERS.TOTAL')}</TableCell> */}
										<TableCell>{t('TABLE_HEADERS.ACTIONS')}</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{orderProducts.map((item) => {
										const src = `${ASSETS_BASE_URL}/ProductImages/${item.productsData.product_number}.png`;
										const maxAllowedForItem = getItemMaxQty(item);

										return (
											<TableRow
												key={item.product_id}
												sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
												<TableCell>
													<Box
														sx={{
															display: "flex",
															alignItems: "center",
															gap: "8px",
															justifyContent: "flex-start",
														}}>
														<img
															src={src}
															alt={item.product_name}
															onError={handleError}
															style={{
																width: "40px",
																height: "40px",
																objectFit: "cover",
																borderRadius: "4px",
															}}
														/>
														<Box>
															<Link
																underline="hover"
																sx={{ cursor: "pointer" }}
																onClick={() => {
																	const url = `/machines/${item.productsData.machine_id}/${item.productsData.product_id}`;
																	handleNavigateToProduct(url);
																}}>
																{item.productsData.product_name}
															</Link>
															<Typography
																variant="body2"
																color="textSecondary"
																fontSize={"11px"}>
																{t('UI_TEXT.PART')} {item.productsData.product_number}
															</Typography>
														</Box>
													</Box>
												</TableCell>
												<TableCell align="center">
													<Box className="quantity-controls">
														<IconButton
															size="small"
															onClick={() =>
																handleUpdateQuantity(item.productsData.product_id, -1)
															}>
															<RemoveIcon />
														</IconButton>
														<TextField
															type="number"
															size="small"
															value={item.product_quantity}
															onChange={(e) =>
																handleQuantityChange(
																	item.productsData.product_id,
																	e.target.value
																)
															}
															onBlur={() => handleBlur(item.productsData.product_id)}
															className="quantity-input"
															InputProps={{
																inputProps: {
																	min: 1,
																	max: maxAllowedForItem,
																},
															}}
															sx={{
																"& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
																{
																	"-webkit-appearance": "none",
																	margin: 0,
																},
																"& input[type=number]": {
																	"-moz-appearance": "textfield",
																},
															}}
														/>
														<IconButton
															size="small"
															onClick={() =>
																handleUpdateQuantity(item.productsData.product_id, 1)
															}>
															<AddIcon />
														</IconButton>
													</Box>
												</TableCell>
												<TableCell align="right">
													{/* {currencySymbol}
													{parsePrice(
														item.productsData[`price_${selectedSiteCurrency}`]
													).toFixed(2)}
													*/}
												</TableCell>
												<TableCell align="right">
													{/* {currencySymbol}
													{(
														parsePrice(item.productsData[`price_${selectedSiteCurrency}`]) *
														item.product_quantity
													).toFixed(2)}
													*/}
												</TableCell>
												<TableCell>
													<IconButton
														color="primary"
														onClick={() => handleRemoveItem(item.productsData.product_id)}>
														<DeleteIcon />
													</IconButton>
												</TableCell>
											</TableRow>
										);
									})}
								</TableBody>
							</Table>
						</TableContainer>
						</Box>
						<Box sx={{ width: "100%", mt: 2, p: 2, borderTop: '1px solid #eee' }}>
							<Box display="flex" justifyContent="space-between" mb={0.5}>
								{/* <Typography variant="body2">{t('TABLE_HEADERS.SUBTOTAL')}</Typography> */}
								{/* <Typography variant="body2">{currencySymbol}{orderSummary.subtotal.toFixed(2)}</Typography> */}
							</Box>
							<Divider sx={{ my: 1 }} />
							<Box display="flex" justifyContent="space-between">
								{/* <Typography variant="h6" fontWeight="bold">{t('TABLE_HEADERS.TOTAL')}</Typography> */}
								{/* <Typography variant="h6" fontWeight="bold">{currencySymbol}{orderSummary.total.toFixed(2)}</Typography> */}
							</Box>
						</Box>
					</Box>
				);
			case 2:
				return (
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "flex-start",
							alignItems: "flex-start",
							rowGap: "20px",
							width: "100%",
							height: "100%",
						}}>
						<Typography variant="body1" fontWeight={"bold"}>
							{t('UI_TEXT.ORDER_FREQUENCY')}
						</Typography>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<FormControl fullWidth size="small">
								<InputLabel id="frequency-label">{t('LABELS.FREQUENCY')}</InputLabel>
								<Select
									labelId="frequency-label"
									id="frequency"
									value={frequency}
									label={t('LABELS.FREQUENCY')}
									onChange={handleFrequencyChange}>
									<MenuItem value="daily">{t('MENU_ITEMS.DAILY')}</MenuItem>
									<MenuItem value="weekly">{t('MENU_ITEMS.WEEKLY')}</MenuItem>
									<MenuItem value="monthly">{t('MENU_ITEMS.MONTHLY')}</MenuItem>
									<MenuItem value="quarterly">{t('MENU_ITEMS.QUARTERLY')}</MenuItem>
									<MenuItem value="yearly">{t('MENU_ITEMS.YEARLY')}</MenuItem>
									{/* <MenuItem value="custom">Custom</MenuItem> */}
								</Select>
							</FormControl>

							{frequency === "custom" && (
								<Stack direction="row" spacing={1} alignItems="center" sx={{ width: "100%" }}>
									<TextField
										size="small"
										label={t('LABELS.NUMBER')}
										type="number"
										value={customNumber}
										onChange={(e) => {
											const val = e.target.value;
											if (val === "" || /^[0-9\b]+$/.test(val)) {
												setCustomNumber(val);
											}
										}}
										sx={{ width: "100%" }}
										inputProps={{ min: 1 }}
									/>
									<FormControl size="small" sx={{ minWidth: 100 }}>
										<InputLabel id="custom-unit-label">{t('LABELS.UNIT')}</InputLabel>
										<Select
											labelId="custom-unit-label"
											id="custom-unit"
											value={customUnit}
											label={t('LABELS.UNIT')}
											onChange={(e) => setCustomUnit(e.target.value)}>
											<MenuItem value="days">{t('MENU_ITEMS.DAYS')}</MenuItem>
											<MenuItem value="months">{t('MENU_ITEMS.MONTHS')}</MenuItem>
										</Select>
									</FormControl>
								</Stack>
							)}

							<DateTimePicker
								label={t('TABLE_HEADERS.START_DATE')}
								value={startDate}
								onChange={handleStartDateChange}
								ampm={false} // Use 24-hour format
								minutesStep={15} // 15-minute intervals
								views={['year', 'month', 'day', 'hours', 'minutes']} // Customize available views
								desktopModeMediaQuery="(min-width:0px)"
								slotProps={{
									actionBar: { actions: ['clear', 'cancel', 'accept'] },
									dialog: {
										sx: datePickerDialogSx,
									},
									popper: {
										placement: "auto-start",
										strategy: "fixed",
										modifiers: [
											{
												name: "flip",
												enabled: true,
												options: {
													fallbackPlacements: ["top-start", "bottom-start"],
												},
											},
											{
												name: "preventOverflow",
												enabled: true,
												options: { boundary: "viewport", padding: 8 },
											},
										],
									},
									textField: {
										size: "small",
										fullWidth: true,
										error: !!dateErrors.startDate,
										helperText: dateErrors.startDate,
										sx: datePickerTextFieldSx,
									}
								}}
							/>
							<DateTimePicker
								label={t('TABLE_HEADERS.END_DATE')}
								value={endDate}
								onChange={handleEndDateChange}
								ampm={false} // Use 24-hour format
								minutesStep={15} // 15-minute intervals
								views={['year', 'month', 'day', 'hours', 'minutes']} // Customize available views
								desktopModeMediaQuery="(min-width:0px)"
								slotProps={{
									actionBar: { actions: ['clear', 'cancel', 'accept'] },
									dialog: {
										sx: datePickerDialogSx,
									},
									popper: {
										placement: "auto-start",
										strategy: "fixed",
										modifiers: [
											{
												name: "flip",
												enabled: true,
												options: {
													fallbackPlacements: ["top-start", "bottom-start"],
												},
											},
											{
												name: "preventOverflow",
												enabled: true,
												options: { boundary: "viewport", padding: 8 },
											},
										],
									},
									textField: {
										size: "small",
										fullWidth: true,
										error: !!dateErrors.endDate,
										helperText: dateErrors.endDate,
										sx: datePickerTextFieldSx,
									}
								}}
							/>

						</LocalizationProvider>

						<Typography variant="body2" color="text.secondary">
							{frequency === "custom" ? (
								<Trans
									i18nKey={MESSAGES.CUSTOM_REPEAT_ORDER}
									values={{ number: customNumber || '[X]', unit: customUnit }}
									components={{ strong: <strong /> }}
								/>
							) : (
								<Trans
									i18nKey={MESSAGES.STANDARD_REPEAT_ORDER}
									values={{ frequency }}
									components={{ strong: <strong /> }}
								/>
							)}
						</Typography>
						<FormControl fullWidth size="small">
							<InputLabel id="status-label">{t('TABLE_HEADERS.STATUS')}</InputLabel>
							<Select
								labelId="status-label"
								id="status"
								value={status}
								label={t('TABLE_HEADERS.STATUS')}
								onChange={(e) => setStatus(e.target.value)}>
								<MenuItem value="active">{t('MENU_ITEMS.ACTIVE')}</MenuItem>
								<MenuItem value="inactive">{t('MENU_ITEMS.INACTIVE')}</MenuItem>
							</Select>
						</FormControl>

						<FormControlLabel
							control={
								<Switch
									checked={notifyBeforeOrder}
									onChange={(e) => setNotifyBeforeOrder(e.target.checked)}
								/>
							}
							label={t('LABELS.NOTIFY_EVERY_TIME')}
						/>
					</Box>
				);

			default:
				return <Typography>{t('UI_TEXT.UNKNOWN_STEP')}</Typography>;
		}
	};
	const validateDates = (startDateValue, endDateValue) => {
		const now = dayjs(); // Use current date and time instead of startOf('day')
		const newErrors = { startDate: '', endDate: '' };
		const isEditingSchedule = Boolean(selectedOrder);

		// Validate start date
		if (startDateValue) {
			if (!isEditingSchedule && dayjs(startDateValue).isBefore(now)) {
				newErrors.startDate = "Start date and time cannot be in the past. Please select current time or a future date and time.";
			}
		}

		// Validate end date
		if (endDateValue) {
			if (!isEditingSchedule && dayjs(endDateValue).isBefore(now)) {
				newErrors.endDate = "End date and time cannot be in the past. Please select a future date and time.";
			} else if (startDateValue) {
				if (dayjs(endDateValue).isBefore(dayjs(startDateValue))) {
					newErrors.endDate = "End date and time cannot be before start date and time.";
				}
			}
		}

		setDateErrors(newErrors);
		return !newErrors.startDate && !newErrors.endDate;
	};



	return (
		<Modal
			open={open}
			onClose={(event, reason) => {
				event.stopPropagation(); // Prevent the click event from propagating

				if (reason) {
					handleCloseDialog();
				}
			}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description">
			<Box sx={style}>
				{(isModalLoading || isSubmitting) && (
					<Box
						sx={{
							position: "absolute",
							inset: 0,
							bgcolor: "rgba(255,255,255,0.75)",
							zIndex: 10,
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							justifyContent: "center",
							rowGap: 1,
							borderRadius: 2,
						}}
					>
						<CircularProgress size={32} />
						<Typography variant="body2">
							{isSubmitting ? t('GENERAL.SUBMITTING_SCHEDULE') : t('GENERAL.LOADING_SCHEDULE_DETAILS')}
						</Typography>
					</Box>
				)}
				<Box
					sx={{
						display: "flex",
						flexDirection: "row",
						justifyContent: "space-between",
						alignItems: "center",
						mb: 2,
						mt: 1,
						width: "100%",
					}}>
					<Box>
						<Typography variant="h5" sx={{ m: 0, fontWeight: "bold" }}>
							{selectedOrder && (selectedOrder.job_id || selectedOrder.id)
								? t('UI_TEXT.UPDATE_ORDER_SCHEDULE')
								: t('UI_TEXT.SET_ORDER_SCHEDULE')
							}
						</Typography>
						<Typography variant="body2" color="text.secondary">
							{selectedOrder && (selectedOrder.job_id || selectedOrder.id)
								? t('UI_TEXT.UPDATE_OPTIONS_FOR_SCHEDULING_ORDER')
								: t('UI_TEXT.CHOOSE_OPTIONS_FOR_SCHEDULING_ORDER')
							}
						</Typography>

					</Box>
					<IconButton
						aria-label="close"
						onClick={(e) => {
							e.stopPropagation(); // Prevent the click event from propagating
							handleCloseDialog();
						}}>
						<CloseIcon />
					</IconButton>
				</Box>

				<Box sx={{ width: "100%" }}>
					<Stepper activeStep={currentStep} alternativeLabel>
						{steps.map((label) => (
							<Step key={label}>
								<StepLabel>{label}</StepLabel>
							</Step>
						))}
					</Stepper>
					{error && (
						<Alert severity="error" sx={{ width: "100%", my: 1 }}>
							{error}
						</Alert>
					)}
					<Box mt={2}>{renderStep(currentStep)}</Box>

					<Box mt={1} display="flex" justifyContent="center" gap={2}>
						<Button disabled={currentStep === 0 || isModalLoading || isSubmitting} onClick={handleBack} variant="outlined">
							{t('BUTTON.BACK')}
						</Button>

						{!isLastStep ? (
							<Button onClick={handleNext} variant="contained" disabled={isModalLoading || isSubmitting}>
								{t('BUTTON.NEXT')}
							</Button>
						) : (
								<Button onClick={handleSetSchedule} variant="contained" color="primary" disabled={isModalLoading || isSubmitting}>
								{selectedOrder && (selectedOrder.job_id || selectedOrder.id)
									? t('BUTTON.UPDATE_SCHEDULE')
									: t('BUTTON.SET_SCHEDULE')
								}
							</Button>
						)}

					</Box>
				</Box>

				{/* <Box
					sx={{
						display: "flex",
						flexDirection: "row",
						justifyContent: "center",
						alignItems: "center",
						mb: 2,
						mt: 1,
						width: "100%",
						columnGap: "10px",
					}}>
					<Button
						variant="contained"
						onClick={(e) => {
							e.stopPropagation(); // Prevent the click event from propagating
							handleSetSchedule();
						}}>
						Set Schedule
					</Button>
					<Button
						variant="outlined"
						onClick={(e) => {
							e.stopPropagation(); // Prevent the click event from propagating
							handleCloseDialog();
						}}>
						Close
					</Button>
				</Box> */}
				<Typography variant="body1" color="#aaa" fontSize={"11px"} my={1}>
					{t('UI_TEXT.SHIPPING_NOT_SAME_ADDRESS')}
				</Typography>
			</Box>
		</Modal>
	);
};

export default ScheduleOrder;
